import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import helpers from '../utils/helpers'
import moment, { utc } from 'moment'

export default {
  computed: {
    ...mapState({
      latestPos: state => state.location.latest,
      distanceToSite: state => state.location.distanceToSite.value
    }),
    ...mapGetters({
      callDetail: 'calls/getActiveCall'
    })
  },
  methods: {
    ...mapActions({
      readCalls: 'calls/readCalls',
      accept: 'calls/accept',
      arrive: 'calls/arrived',
      arrivalCompleted: 'calls/arrivalCompleted',
      depart: 'calls/depart',
      endTravel: 'calls/endTravel',
      travel: 'calls/travel',
      reset: 'calls/reset',
      complete: 'calls/complete',
      fetchLocation: 'location/fetch',
      recordLocation: 'location/record'
    }),

    ...mapMutations({
      onSiteTime: 'calls/ON_SITE_TIME'
    }),

    // Accept call
    _mAcceptCall(callId) {
      return this.fetchLocation()
        .then(pos => {
          const params = helpers.positionToPlain(pos)
          return this.accept({ id: callId, position: params })
        })
        .catch(e => {
          if (e.toString() === '[object PositionError]') {
            console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
            return this.accept({ id: callId, position: this.latestPos })
          } else {
            console.log('ERROR Accepting call.')
            return e
          }
        })
    },

    _mArrivalCompleted(id) {
      return this.arrivalCompleted({
        id: id,
        arrival_completed_at: moment()
          .tz('Europe/London')
          .format('YYYY-MM-DD HH:mm:ss')
      })
    },

    // Arrive call
    _mArriveCall(callId) {
      return this.fetchLocation()
        .then(pos => {
          const params = helpers.positionToPlain(pos)
          params['distance_to_site'] = this.distanceToSite
          console.log('****************** ' + this.callDetail.arrived_at)
          return this.arrive({
            id: callId,
            position: params,
            arrived_at: moment(this.callDetail.arrived_at)
              .tz('Europe/London')
              .format('YYYY-MM-DD HH:mm:ss')
          })
        })
        .catch(e => {
          if (e.toString() === '[object PositionError]') {
            this.latestPos['distance_to_site'] = this.distanceToSite
            console.log(
              'ERROR FETCHING LOCATION. use latest. ARRIVE',
              this.latestPos
            )
            return this.arrive({ id: callId, position: this.latestPos })
          } else {
            console.log('ERROR Arriving call.')
            return e
          }
        })
    },

    _mSaveArrivalTime(callId) {
      var dateTime = moment()
        .tz('Europe/London')
        .toISOString(true)
      var payload = { callId: callId, dateTime: dateTime }
      this.onSiteTime(payload)
    },

    // Travel call
    _mTravelCall(callId) {
      return this.fetchLocation()
        .then(pos => {
          const params = helpers.positionToPlain(pos)
          this.travel({ id: callId, position: params })
        })
        .catch(e => {
          if (e.toString() === '[object PositionError]') {
            console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
            this.travel({ id: callId, position: this.latestPos })
          } else {
            console.log('ERROR Travelling call.')
            return e
          }
        })
    },

    // Complete call
    _mCompleteCall(params) {
      return this.fetchLocation()
        .then(pos => {
          params.position = helpers.positionToPlain(pos)
          params['distance_to_site'] = this.distanceToSite
          this.complete(params)
        })
        .catch(e => {
          console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
          params.position = this.latestPos
          this.latestPos['distance_to_site'] = this.distanceToSite
          this.complete(params)
        })
    },

    _mDepartCall(params) {
      return this.fetchLocation()
        .then(pos => {
          params.position = helpers.positionToPlain(pos)
          params['distance_to_site'] = this.distanceToSite
          this.depart(params)
        })
        .catch(e => {
          console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
          params.position = this.latestPos
          this.latestPos['distance_to_site'] = this.distanceToSite
          this.depart(params)
        })
    },

    _mEndTravelCall(params) {
      return this.fetchLocation()
        .then(pos => {
          params.position = helpers.positionToPlain(pos)
          params['distance_to_site'] = this.distanceToSite
          this.endTravel(params)
        })
        .catch(e => {
          console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
          params.position = this.latestPos
          this.latestPos['distance_to_site'] = this.distanceToSite
          this.endTravel(params)
        })
    },

    // Travel call
    _mResetCall(callId) {
      return this.fetchLocation()
        .then(pos => {
          const params = helpers.positionToPlain(pos)
          this.reset({ id: callId, position: params })
        })
        .catch(e => {
          console.log('ERROR FETCHING LOCATION. use latest.', this.latestPos)
          this.reset({ id: callId, position: this.latestPos })
        })
    }
  }
}
